import { array } from 'fp-ts';
import { useSelector } from 'react-redux';
import { OrderItem } from '@mews-commander/types';
import { ConvertedCurrencyValue } from '@mews-commander/ui';
import {
    isCurrentEnterpriseInMultiTaxEnvironment,
    getCurrentEnterpriseDefaultCurrencyCode,
} from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getOrderItemsTotalAmount } from '@mews-commander/legacy-entities/src/selectors/orderItems';
import { RateName } from '../../../../../components/commander-ui';
import CountLabel from './CountLabel';
import TogglableList from './TogglableList';
import DefaultProductOrderItemsList from './DefaultProductOrderItemsList';

interface Props {
    serviceId: string;
    rateId: string;
    defaultProductOrderItems: OrderItem[];
}
const DefaultProductOrderItemsGrid = ({ serviceId, rateId, defaultProductOrderItems }: Props) => {
    const defaultCurrencyCode: string = useSelector(getCurrentEnterpriseDefaultCurrencyCode);
    const isMultiTaxEnvironment: boolean = useSelector(isCurrentEnterpriseInMultiTaxEnvironment);
    const defaultProductOrderItemsTotalAmount = getOrderItemsTotalAmount(defaultProductOrderItems, defaultCurrencyCode);

    return array.isNonEmpty(defaultProductOrderItems) ? (
        <TogglableList
            label={<CountLabel count={array.size(defaultProductOrderItems)} item={<RateName rateId={rateId} />} />}
            additionalInfo={
                <ConvertedCurrencyValue amount={defaultProductOrderItemsTotalAmount} net={isMultiTaxEnvironment} />
            }
        >
            <DefaultProductOrderItemsList
                serviceId={serviceId}
                nights={defaultProductOrderItems}
                isMultiTaxEnvironment={isMultiTaxEnvironment}
            />
        </TogglableList>
    ) : null;
};

export default DefaultProductOrderItemsGrid;
